import { useCallback, useMemo, useState } from "react";
import moment from "moment";
import useClockSessionMutations from "graphql/useClockSessionMutations";
import useClockInMutations from "graphql/useclockInMutations";
import { useMessaging } from "context/MessagingContext";
import { useTranslation } from "react-i18next";
import useWindowSize from "useWindowSize";
import { useFormik } from "formik";
import Input from "components/common/Input";
import { Button, DatePicker, Skeleton } from "antd";
import Trash from "components/icons/Trash";
import s from "../styles";
import ls from "components/common/ListWithMoreOptions/ItemRow/styles";
import CustomSelector from "components/common/Selector";
import Colors from "assets/Colors";
import { useSessionClockIns } from "../../../graphql/useClockIns";
import { useClockSessionById } from "../../../graphql/useClockSessions";
import {
  getClockSessionDurationForUpdate,
  getUpdateObject,
} from "../../../helpers/utils";
import { disabledDate, disabledTime, secondsToTime } from "helpers/dataHelper";

// const validateEdit = (clockSessions, currentObject) => {
//   let currentIndex = clockSessions.findIndex(
//     (item) => item._id === currentObject._id
//   );

//   const lastIndex = clockSessions.length - 1;

//   const constraints = {
//     previous: null,
//     next: null,
//   };

//   if (currentIndex === -1) {
//     currentIndex = lastIndex;
//     if (clockSessions[currentIndex]?.sessionEnd) {
//       constraints.previous = {
//         sessionEnd: clockSessions[currentIndex].sessionEnd,
//       };
//     } else {
//       return constraints;
//     }
//   }

//   const hasPrevious = currentIndex > 0;
//   const hasNext = currentIndex < lastIndex;

//   if (hasPrevious) {
//     const previousSession = clockSessions[currentIndex - 1];
//     constraints.previous = {
//       sessionEnd: previousSession.sessionEnd,
//     };
//   }

//   if (hasNext) {
//     const nextSession = clockSessions[currentIndex + 1];
//     constraints.next = {
//       sessionStart: nextSession.sessionStart,
//     };
//   }

//   return constraints;
// };

// const isValidDate = (date, constraints) => {
//   if (!date) return true;

//   if (constraints) {
//     const { previous, next } = constraints;

//     if (previous && date.isBefore(moment(previous.sessionEnd))) {
//       return false;
//     }

//     if (next && date.isAfter(moment(next.sessionStart))) {
//       return false;
//     }
//   }

//   return true;
// };

// const isValidDateTime = (dateTime, constraints) => {
//   if (!dateTime) return true;

//   if (constraints) {
//     const { previous, next } = constraints;

//     if (previous && moment(dateTime).isBefore(moment(previous.sessionEnd))) {
//       return false;
//     }

//     if (next && moment(dateTime).isAfter(moment(next.sessionStart))) {
//       return false;
//     }
//   }
//   return true;
// };

const ClockSessionRowForm = ({ item, setUpdating }) => {
  const { t } = useTranslation();

  const { clockIns } = useSessionClockIns(item._id);

  const [startClockIn, endClockIn] = useMemo(() => {
    if (clockIns.length === 0) {
      return [undefined, undefined];
    }
    if (clockIns.length === 1) {
      return [clockIns[0], undefined];
    }

    if (
      moment(clockIns[0].clockDatetime).isAfter(
        moment(clockIns[1].clockDatetime)
      )
    ) {
      return [clockIns[1], clockIns[0]];
    }
    return [clockIns[0], clockIns[1]];
  }, [clockIns]);

  // console.log(
  //   "*** ",
  //   item,
  //   startClockIn?.clockDatetime,
  //   startClockIn?.sessionId,
  //   startClockIn?.chainSessionId,
  //   "/",
  //   endClockIn?.clockDatetime,
  //   endClockIn?.sessionId,
  //   endClockIn?.chainSessionId
  // );

  const previousSessionId =
    (startClockIn &&
      startClockIn.sessionId !== item._id &&
      startClockIn.sessionId) ||
    undefined;
  const { clockSession: previousSession, loading: loading1 } =
    useClockSessionById(previousSessionId);

  const nextSessionId =
    (endClockIn &&
      endClockIn.chainSessionId &&
      endClockIn.chainSessionId !== item._id &&
      endClockIn.chainSessionId) ||
    undefined;

  const { clockSession: nextSession, loading: loading2 } =
    useClockSessionById(nextSessionId);

  // console.log("**** previousSession", previousSessionId, previousSession);
  // console.log("**** nextSessionId", nextSessionId, nextSession);

  const { updateClockSession, deleteClockSession } = useClockSessionMutations(
    item.storeId
  );

  const { updateClockIn } = useClockInMutations(item.storeId);

  const { setErrorMessage, setConfirmMessage } = useMessaging();

  const [saving, setSaving] = useState(false);

  // const onUpdateSuccess = useCallback(() => {
  //   setInfoMessage({
  //     titleAlert: t("containers.ClockSessions.sessionUpdated"),
  //     info1: t("containers.ClockSessions.sessionUpdatedFind"),
  //   });
  // }, []);

  // const onAddSuccess = useCallback(() => {
  //   setInfoMessage({
  //     titleAlert: t("containers.ClockSessions.sessionAdded"),
  //     info1: t("containers.ClockSessions.sessionAddedFind"),
  //   });
  // }, []);

  const onDelete = useCallback(() => {
    setConfirmMessage({
      titleAlert: t("containers.ClockSessions.delete"),
      confirm1: `${t("containers.ClockSessions.deleteSession")}`,
      confirm2: t("containers.ClockSessions.actionCannotBeUndone"),
      onConfirm: () => {
        deleteClockSession(item)
          .then(() => {
            // setClockSessionInEdit(null);
          })
          .catch((e) => setErrorMessage({ error: e }));
      },
    });
  }, []);

  const { width } = useWindowSize();

  const { handleSubmit, values, setFieldValue, isValid, dirty } = useFormik({
    // enableReinitialize: true,
    initialValues: {
      _id: item._id,
      userId: item?.userId,
      storeId: item?.storeId,
      status: item?.status,
      type: item?.type,
      chainId: item.chainId,
      sessionStart: item.sessionStart,
      sessionEnd: item.sessionEnd,
      sessionDuration: item.sessionDuration,
      notes: item.notes,
      updated: item.updated,
      updateDatetime: new Date(),
      creationDatetime: item.creationDatetime || new Date(),
    },
    onSubmit: async (data) => {
      setSaving(true);
      const updateDatetime = new Date();
      const sessionStart = moment(data.sessionStart).toDate();
      const sessionEnd = moment(data.sessionEnd).toDate();

      const startChanged = !moment(item.sessionStart).isSame(sessionStart);
      const endChanged = !moment(item.sessionEnd).isSame(sessionEnd);

      try {
        if (startChanged) {
          if (previousSession) {
            // previous session exists
            const toUpdatePreviousSession = getUpdateObject(previousSession);
            await updateClockSession(previousSession, {
              ...toUpdatePreviousSession,
              sessionEnd: sessionStart,
              updateDatetime,
              updated: true,
              sessionDuration: getClockSessionDurationForUpdate(
                toUpdatePreviousSession.sessionStart,
                sessionStart
              ),
            });
          }
          if (startClockIn) {
            // update the start clockIn
            const toUpdateStartClockIn = getUpdateObject(startClockIn);
            await updateClockIn(startClockIn, {
              ...toUpdateStartClockIn,
              updated: true,
              clockDatetime: sessionStart,
              updateDatetime,
            });
          }
        }
        if (endChanged) {
          if (nextSession) {
            // next session exists
            const toUpdateNextSession = getUpdateObject(nextSession);
            await updateClockSession(nextSession, {
              ...toUpdateNextSession,
              sessionStart: sessionEnd,
              updated: true,
              sessionDuration: getClockSessionDurationForUpdate(
                sessionEnd,
                toUpdateNextSession.sessionEnd
              ),
              updateDatetime,
            });
          }
          if (endClockIn) {
            // update the end clockIn
            const toUpdateEndClockIn = getUpdateObject(endClockIn);
            await updateClockIn(endClockIn, {
              ...toUpdateEndClockIn,
              updated: true,
              clockDatetime: sessionEnd,
              updateDatetime,
            });
          }
        }
        await updateClockSession(item, {
          ...data,
          sessionStart,
          sessionEnd,
          updated: true,
          sessionDuration: getClockSessionDurationForUpdate(
            sessionStart,
            sessionEnd
          ),
        });
        /**
         const createClockInData = (clockIn, dateTime) => {};
         const clockInDataStart = createClockInData(
         clockInStart,
         values.sessionStart
         );
         const clockInDataEnd = createClockInData(clockInEnd, values.sessionEnd);
         const clockSessionData = [];

         if (item.status === "new") {
         const data = await addClockSession(clockSessionData);
         await addClockIn({
         ...createClockInData(clockInDataStart, values.sessionStart),
         sessionId: data._id,
         chainSessionId: data._id,
         });

         await addClockIn({
         ...createClockInData(clockInDataEnd, values.sessionEnd),
         sessionId: data._id,
         chainSessionId: data._id,
         type: "out",
         });

         onAddSuccess();
         } else {
         await updateClockSession(item, clockSessionData);

         if (clockInStart) {
         await updateClockIn(clockInStart, clockInDataStart);
         }

         if (clockInEnd) {
         await updateClockIn(clockInEnd, clockInDataEnd);
         }

         onUpdateSuccess();
         }

         setUpdating(false);
         setClockInEdit(null);
         setClockSessionInEdit(null);
         */
        setUpdating(false);
      } catch (error) {
        console.log("error", error);
        console.error(error);
        setErrorMessage({ error });
      } finally {
        setSaving(false);
      }
    },
  });

  if (loading1 || loading2) {
    return [
      <Skeleton
        key="clockInRowFormDateTime"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
      <Skeleton
        key="clockInRowFormAction"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
      <Skeleton
        key="clockInRowFormNotes"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
      <Skeleton
        key="clockInRowFormNotes"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
      <Skeleton
        key="clockInRowFormNotes"
        active
        paragraph={{ rows: 0 }}
        style={{ width: "100%" }}
      />,
    ];
  }

  return [
    <DatePicker
      key="sessionRowFormStart"
      disabled={item.status === "open"}
      style={{ maxWidth: "200px", marginLeft: "20px", height: "38px" }}
      defaultValue={item.sessionStart ? moment(item.sessionStart) : null}
      showTime
      format="YYYY-MM-DD hh:mm A"
      disabledDate={(current) =>
        disabledDate(current, previousSession?.sessionStart, values?.sessionEnd)
      }
      disabledTime={(current) =>
        disabledTime(current, previousSession?.sessionStart, values?.sessionEnd)
      }
      onChange={(newTime) => {
        const newTimeWithoutSeconds = moment(newTime)
          .seconds(0)
          .milliseconds(0);
        setFieldValue("sessionStart", newTimeWithoutSeconds);
      }}
    />,
    <DatePicker
      key="sessionRowFormEnd"
      disabled={item.status === "open"}
      style={{ maxWidth: "200px", marginLeft: "20px", height: "38px" }}
      defaultValue={item.sessionEnd ? moment(item.sessionEnd) : null}
      showTime
      format="YYYY-MM-DD hh:mm A"
      disabledDate={(current) =>
        disabledDate(current, values.sessionStart, nextSession?.sessionEnd)
      }
      disabledTime={(current) =>
        disabledTime(current, values.sessionStart, nextSession?.sessionEnd)
      }
      onChange={(newTime) => {
        const newTimeWithoutSeconds = moment(newTime)
          .seconds(0)
          .milliseconds(0);
        setFieldValue("sessionEnd", newTimeWithoutSeconds);
      }}
    />,
    <ls.TableCell key="sessionRowFormType">
      <CustomSelector
        placeholder="-"
        border={Colors.text_secondary}
        options={[
          {
            name: t("containers.ClockSessions.sessionin"),
            value: "in",
            // disabled: true,
          },
          {
            name: t("containers.ClockSessions.sessionpause"),
            value: "pause",
            // disabled: true,
          },
        ]}
        style={{ width: "128px" }}
        value={values.type}
        onChange={(action) => {
          setFieldValue("type", action);
        }}
      />
    </ls.TableCell>,
    <ls.TableCell key="sessionDuration">
      {item.sessionDuration ? secondsToTime(item.sessionDuration, t) : "-"}
    </ls.TableCell>,
    <ls.TableCell key="sessionRowFormNotes">
      <Input
        placeholder="-"
        style={{
          width: width < 720 ? "100%" : "160px",
        }}
        value={values.notes}
        onChange={(notes) => {
          setFieldValue("notes", notes.target.value);
        }}
      />
    </ls.TableCell>,
    <ls.TableCell
      key="sessionRowFormActionButtons"
      style={{
        display: "flex",
        justifyContent: "end",
        gap: "10px",
        width: "100%",
        paddingRight: "20px",
      }}
    >
      <Button
        type="text"
        onClick={() => {
          if (item.status === "new") {
            setUpdating(false);
          } else {
            onDelete();
          }
        }}
      >
        <Trash />
      </Button>
      <s.button
        disabled={saving}
        onClick={() => {
          setUpdating(false);
        }}
      >
        {t("containers.ClockSessions.cancel")}
      </s.button>
      <s.button
        loading={saving}
        disabled={!isValid || !dirty}
        background={Colors.primary}
        onClick={() => handleSubmit()}
      >
        {t("containers.ClockSessions.finish")}
      </s.button>
      {/* </div> */}
    </ls.TableCell>,
  ];
};

export default ClockSessionRowForm;
